export default __webpack_public_path__ + "static/media/NTEX.14b66ceb.pdf";